export enum ETipo {
  EXTERNO = 'EXT',
  INTERNO = 'INT'
}
